import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'

import InstallChoice from './component'

const mapStateToProps = (state) => ({
  embedSnippet: OrgSelectors.getEmbedSnippet(state) || '',
  installOption: OrgSelectors.getInstallOption(state),
})

const mapDispatchToProps = (dispatch) => ({
  action: bindActionCreators(
    {
      setInstallOption: OrgActions.setInstallOption,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onInstallChange:
      (props) =>
      ({ value }) => {
        props.action.setInstallOption(value)
      },
    onHelpWidgetClick: () => (value) => {
      window.drift.api.startInteraction({ interactionId: value })
    },
  })
)(InstallChoice)
